import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {AlertService, ConstantService} from '@app/_services';
import { MediaUploadService } from '@app/_services/media-upload.service';
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { MsgCampaign } from "../msg-campaign";
import { MsgCampaignService } from "../msg-campaign.service";
import {MsgTemplateService} from '@app/_components/msg-template/msg-template.service';
import {MsgService} from '@app/_components/msg';

@Component({
    selector: "app-msg-campaign",
    templateUrl: "./msg-campaign.component.html",
    styleUrls: ["./msg-campaign.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class MsgCampaignComponent implements OnInit, OnDestroy {
  countries: any;
  guestProfile = true;
  guestMasterProfile = false;
  ownerLeadProfile = false;
  propertyLeadProfile = false;
  employeeProfile = false;
  ownerProfile = false;
  realtorProfile = false;
  contacts = false;
  travelAgentProfile = false;
  uploadedFiles: any[] = [];
  tinyMceInit: any;

  constructor(
    private primengConfig: PrimeNGConfig,
    private msgCampaignService: MsgCampaignService,
    private msgService: MsgService,
    private alertService: AlertService,
    private messageService: MessageService,
    private constantService: ConstantService,
    private confirmationService: ConfirmationService,
    private msgTemplateService: MsgTemplateService,
    private formBuilder: UntypedFormBuilder,
    private mediaUploadService: MediaUploadService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    (this.formTitle = data.title),
      (this.msgCampaign = data.msgCampaign),
      (this.statuses = msgCampaignService.statuses);
    this.countries = this.constantService.countries;
  }

  @Input() msgCampaign: MsgCampaign;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  msgCampaignId: number;
  currentDate: any;
  currentSearchForm: any;
  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;
  msgVOListUpdated: boolean;

  statuses: any;
  msgTemplates: any;
  msgCountList: any;

  travelAgentPortalAccessOptions = [
    { label: 'All', value: null },
    { label: 'Not Invited (0)', value: 0 },
    { label: 'Invited / Pending (2)', value: 2 },
    { label: 'Active (1)', value: 1 },
  ];

  validationMessages = {
    msgCampaignId: [],
    name: [{ type: 'required', message: 'Required' }],
    description: [],
    status: [],
    type: [{ type: 'required', message: 'Required' }],
    sendOnDate: [],
    // sendByEmail: [],
    // sendBySms: [],
    senderName: [{ type: 'required', message: 'Required' }],
    senderEmail: [{ type: 'required', message: 'Required' }],
    senderMobileNum: [{ type: 'required', message: 'Required' }],
    senderCountryCode: [{ type: 'required', message: 'Required' }],
    subject: [{ type: 'required', message: 'Required' }],
    preHeader: [],
    emailHtml: [],
    emailText: [],
    mobileText: [],
    headers: [],
    statusMsg: [],
    confId: [],
    trackingId: [],
    opsNotes: [],
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.currentDate = new Date();
    this.formBuild();
    this.buildTinyMceInit();
    this.form1.controls['guestProfile'].setValue(true);

    // if we were passed the whole msgCampaign object
    if (this.msgCampaign) {
      this.msgCampaignId = this.msgCampaign.msgCampaignId;
      if(this.msgCampaign.sendOnDate != undefined && this.msgCampaign.sendOnDate != null){
				this.msgCampaign.sendOnDate = moment(this.msgCampaign.sendOnDate).toDate();
			}
      this.fixDates();
      this.form1.patchValue(this.msgCampaign);
      this.fetchMsgCount();
    }
    this.fetchAllTemplates();
  }

  onFormDelete() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + this.msgCampaignId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  onClearDrafts() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to clear Drafts Id# " + this.msgCampaignId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.clearDfradts();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.msgCampaignService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msgCampaign = res.data.msgCampaign;
          this.form1.patchValue(this.msgCampaign);
          this.msgCampaignId = this.msgCampaign.msgCampaignId;
          this.doAdd.emit(this.msgCampaign);
        },
        (err: any) => {
          console.log("msgCampaign-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log("msgCampaign: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.msgCampaignService.update(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msgCampaign = res.data.msgCampaign;
          this.doUpdate.emit(this.msgCampaign);
        },
        (err: any) => {
          console.log("property-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  sendMsg() {
    console.log("msgCampaign: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;
      this.msgCampaignService.sendMessage(this.msgCampaignId, this.uploadedFiles).subscribe(
        (res: any) => {
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msgCampaign = res.data.msgCampaign;
          this.doUpdate.emit(this.msgCampaign);
        },
        (err: any) => {
          // Do NOT reset formLoading on error — a 504 means the campaign message may have been sent.
          // Keep button disabled to prevent duplicate message sends.
          console.log("sendMsg FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }
  formDelete() {
    try {
      this.msgCampaignService.delete(this.msgCampaign.msgCampaignId).subscribe(
        (res: any) => {
          console.log("msgCampaign-delete SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.doDelete.emit(this.msgCampaign);
        },
        (err: any) => {
          console.log("msgCampaign-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }
  clearDfradts() {
    try {
      this.formLoading = true;
      this.msgService.deleteByMsgCampaignId(this.msgCampaign.msgCampaignId).subscribe(
        (res: any) => {
          console.log("msgCampaign-delete SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msgVOListUpdated = !this.msgVOListUpdated;

        },
        (err: any) => {
          console.log("msgCampaign-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }
  onSearchSubmit(searchForm: any)
  {
    this.currentSearchForm = searchForm;
    this.generateMsgesCount(searchForm,[] );
  }

  private normalizeCampaignSearchFilters(searchForm: any): any {
    const normalizedSearchForm = { ...(searchForm || {}) };

    const formValue = this.form1 ? this.form1.value : {};
    const toBool = (value: any) => value === true;

    // Ensure recipient profile flags always reflect current checkbox state.
    normalizedSearchForm.guestProfile = toBool(formValue.guestProfile);
    normalizedSearchForm.guestMasterProfile = toBool(formValue.guestMasterProfile);
    normalizedSearchForm.ownerLeadProfile = toBool(formValue.ownerLeadProfile);
    normalizedSearchForm.propertyLeadProfile = toBool(formValue.propertyLeadProfile);
    normalizedSearchForm.employeeProfile = toBool(formValue.employeeProfile);
    normalizedSearchForm.ownerProfile = toBool(formValue.ownerProfile);
    normalizedSearchForm.realtorProfile = toBool(formValue.realtorProfile);
    normalizedSearchForm.contacts = toBool(formValue.contacts);
    normalizedSearchForm.travelAgentProfile = toBool(formValue.travelAgentProfile);
    normalizedSearchForm.travelAgentPortalAccess = formValue.travelAgentPortalAccess != null ? formValue.travelAgentPortalAccess : null;

    // Keep component-level state in sync for child component bindings.
    this.guestProfile = normalizedSearchForm.guestProfile;
    this.guestMasterProfile = normalizedSearchForm.guestMasterProfile;
    this.ownerLeadProfile = normalizedSearchForm.ownerLeadProfile;
    this.propertyLeadProfile = normalizedSearchForm.propertyLeadProfile;
    this.employeeProfile = normalizedSearchForm.employeeProfile;
    this.ownerProfile = normalizedSearchForm.ownerProfile;
    this.realtorProfile = normalizedSearchForm.realtorProfile;
    this.contacts = normalizedSearchForm.contacts;
    this.travelAgentProfile = normalizedSearchForm.travelAgentProfile;

    normalizedSearchForm.msgCampaignId = this.msgCampaignId;

    console.log("msg campaign filters:", {
      msgCampaignId: normalizedSearchForm.msgCampaignId,
      guestProfile: normalizedSearchForm.guestProfile,
      guestMasterProfile: normalizedSearchForm.guestMasterProfile,
      ownerLeadProfile: normalizedSearchForm.ownerLeadProfile,
      propertyLeadProfile: normalizedSearchForm.propertyLeadProfile,
      employeeProfile: normalizedSearchForm.employeeProfile,
      ownerProfile: normalizedSearchForm.ownerProfile,
      realtorProfile: normalizedSearchForm.realtorProfile,
      contacts: normalizedSearchForm.contacts,
      travelAgentProfile: normalizedSearchForm.travelAgentProfile,
      travelAgentPortalAccess: normalizedSearchForm.travelAgentPortalAccess,
      reservationId: normalizedSearchForm.reservationId,
      locationIdListSize: normalizedSearchForm.locationIdList ? normalizedSearchForm.locationIdList.length : 0,
      developmentIdListSize: normalizedSearchForm.developmentIdList ? normalizedSearchForm.developmentIdList.length : 0,
      shortTermRentalIdListSize: normalizedSearchForm.shortTermRentalIdList ? normalizedSearchForm.shortTermRentalIdList.length : 0
    });

    return normalizedSearchForm;
  }

  generateMsgesCount(searchForm, selectedPropertyCodes: any)
  {
    try
    {
      this.formLoading = true;
      const normalizedSearchForm = this.normalizeCampaignSearchFilters(searchForm);
      this.msgCampaignService.generateMsgesCount(normalizedSearchForm)
        .subscribe(
          res =>
          {
            this.formLoading = false;
            this.confirmationService.confirm({
              message:
                "There are total <b>" + res.data.msgVOCount + " </b> of Messages will be generated.<br> These Messages would be in draft status and will not be sent Until you press the send button below." +
                  "<br>Pressing yes would remove the Draft Messages of preview search. Are you sure?",
              header: "Message Generation Confirm",
              icon: "pi pi-exclamation-triangle",
              accept: () => {
                this.generateMsges(normalizedSearchForm, selectedPropertyCodes);
              },
            });
          },
          err =>
          {
            console.log('getAdvertisedRates FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.formLoading = false;
      this.alertService.error(error);
    }
  }
  generateMsges(searchForm, selectedPropertyCodes: any)
  {
    try
    {
      this.formLoading = true;
      const normalizedSearchForm = this.normalizeCampaignSearchFilters(searchForm);
      this.msgCampaignService.generateMsges(normalizedSearchForm)
        .subscribe(
          res =>
          {
            this.formLoading = false;
            this.msgVOListUpdated = !this.msgVOListUpdated;
            // console.log('getAdvertisedRates SUCCESS: ' + JSON.stringify(res.data.advertisedRates));
            this.messageService.add({ sticky: true, key: 'r', severity: 'success', summary: 'Success', detail: 'Updated the following properties with the new settings: <br><br>' + selectedPropertyCodes });
          },
          err =>
          {
            console.log('getAdvertisedRates FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
            this.formLoading = false;
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.formLoading = false;
      this.alertService.error(error);
    }
  }

  generateMsges1() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.form1.value.filter = {};
      this.msgCampaignService.generateMsges(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msgCampaign = res.data.msgCampaign;
          this.doAdd.emit(this.msgCampaign);
        },
        (err: any) => {
          console.log("msgCampaign-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      msgCampaignId: [this.msgCampaignId],
      name: ['', Validators.required],
      description: [],
      status: ['1'],
      type: [],
      sendOnDate: [],
      // sendByEmail: [],
      // sendBySms: [],
      senderName: ['', Validators.required],
      senderEmail: ['', Validators.required],
      senderMobileNum: [''],
      senderCountryCode: ['+1'],
      subject: ['', Validators.required],
      preHeader: [],
      emailHtml: [],
      emailText: [],
      mobileText: [],
      headers: [],
      statusMsg: [],
      confId: [],
      trackingId: [],
      opsNotes: [],
      msgTemplateId: [null],
      guestProfile: [],
      guestMasterProfile: [],
      ownerLeadProfile: [],
      propertyLeadProfile: [],
      employeeProfile: [],
      ownerProfile: [],
      realtorProfile: [],
      contacts: [],
      travelAgentProfile: [],
      travelAgentPortalAccess: [null],
    });
  }

  buildTinyMceInit(): void {
    this.tinyMceInit = {
      height: 300,
      base_url: '/tinymce',
      suffix: '.min',
      plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'backcolor | undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
      automatic_uploads: true,
      paste_data_images: true,
      images_upload_handler: (blobInfo: any, progress: (pct: number) => void) => {
        return new Promise<string>((resolve, reject) => {
          const file = new File(
            [blobInfo.blob()],
            blobInfo.filename(),
            { type: blobInfo.blob().type }
          );
          this.mediaUploadService.upload(file).subscribe({
            next: (item) => {
              if (item.progressPct) progress(item.progressPct);
              if (item.status === 'done' && item.remoteUrl) resolve(item.remoteUrl);
              if (item.status === 'error') reject(item.error);
            }
          });
        });
      }
    };
  }

  ngOnDestroy(): void {
    this.mediaUploadService.clearQueue();
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    // this.msgCampaign.sendOnDate = moment(
    //   this.msgCampaign.sendOnDate
    // ).toDate();
  }
  fetchAllTemplates() {
    if (!this.msgTemplates || this.msgTemplates.length < 1) {
      try {
        this.msgTemplateService.findAllWithoutPage()
            .subscribe(
                res => {
                  console.log('employee Profiles: ' + JSON.stringify(res));
                  this.msgTemplates = (res.data.msgTemplates || []).map((t: any) => ({
                    ...t,
                    searchLabel: `${t.msgTemplateId} - ${t.name}`,
                  }));
                  return this.msgTemplates;
                },
                err => {
                  console.log('Feature-Update FAIL: ' + JSON.stringify(err));
                  this.alertService.error(err);
                },
                () => { });
      } catch (error) {
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
    }
    else {
      return (this.msgTemplates);
    }
  }
  selectTemplate(event)
  {
    const tpl = event.value;
    this.form1.patchValue({
      emailHtml: tpl.emailHtml,
      subject: tpl.subject,
      emailText: tpl.emailText,
      senderCountryCode: tpl.senderCountryCode,
      senderMobileNum: tpl.senderMobileNum,
      mobileText: tpl.mobileText
    });
    // TinyMCE does not always re-render when the bound FormControl is patched
    // programmatically (ControlValueAccessor writeValue fires before the editor
    // is fully ready in some lifecycle scenarios).  Drive the editor directly to
    // guarantee the HTML body field refreshes immediately on template selection.
    try {
      const ed = (window as any).tinymce?.get('emailHtml');
      if (ed) {
        ed.setContent(tpl.emailHtml || '');
      }
    } catch (e) {
      // tinymce not available or editor not yet initialised — patchValue above is the fallback
    }
  }


  updateTableStatus(tableName: any, status: any) {
      if(tableName === 'guest-profile'){
        this.guestProfile = status.checked;
      }
      if(tableName === 'guest-master-profile'){
        this.guestMasterProfile = status.checked;
      }
      if(tableName === 'owner-lead-profile'){
        this.ownerLeadProfile = status.checked;
      }
      if(tableName === 'property-lead-profile'){
        this.propertyLeadProfile = status.checked;
      }
      if(tableName === 'employee-profile'){
        this.employeeProfile = status.checked;
      }
      if(tableName === 'owner-profile'){
        this.ownerProfile = status.checked;
      }
      if(tableName === 'realtor-profile'){
        this.realtorProfile = status.checked;
      }
      if(tableName === 'contacts'){
        this.contacts = status.checked;
      }
      if(tableName === 'travel-agent-profile'){
        this.travelAgentProfile = status.checked;
      }
    }

  fetchMsgCount() {
    try
    {
      this.formLoading=true;
      this.msgCampaignService.getMsgStatusCount(this.msgCampaignId)
        .subscribe(
          res =>
          {
            let totalMsges = 0;
           this.msgCountList = res.data.counts;
           let statuesArray = [];
            for (let x of this.msgService.statuses){
              statuesArray.push(x.name);
            }
            for (let i = 0; i < this.msgCountList.length; i++) {
              let stat = this.msgCountList[i].status;
              if ( statuesArray.includes(stat)){
                totalMsges = totalMsges + this.msgCountList[i].count;
              }
            }
            this.msgCountList.push({'status': 'Total' , 'count' : totalMsges} );
          },
          err =>
          {
            console.log('getAdvertisedRates FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
            this.formLoading = false;
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.formLoading = false;
      this.alertService.error(error);
    }
  }
  myUploader(event: any) {
    this.uploadedFiles = event.currentFiles;
  }


  sendutBoxOMsgs() {
    try {
      this.formLoading = true;

      this.msgCampaignService.sendutBoxOMsgs().subscribe(
        (res: any) => {
          this.formLoading = false;
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Send email successfully",
          });
        },
        (err: any) => {
          // Do NOT reset formLoading on error — a 504 means the outbox messages may have been sent.
          // Keep button disabled to prevent duplicate sends.
          console.log("sendutBoxOMsgs FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {}
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }
}
